module.exports = __webpack_public_path__ + "static/Patients-ea879229487d74c77466177c29de6c59.jpg";